if (!customElements.get("br-sticky-atc")) {
  class BrStickyAtc extends HTMLElement {
    connectedCallback() {
      const section = this.closest(".cc-main-product");
      this.info = section ? section.querySelector(".product-info") : null;
      this.mainButton = this.info ? this.info.querySelector('button[name="add"]') : null;
      if (!this.mainButton || this.closest("quick-add-drawer, quick-add-dialog, quick-add-component")) {
        this.remove();
        return;
      }
      this.addButton = this.querySelector("[data-br-sticky-add]");
      this.price = this.querySelector("[data-br-sticky-price]");
      this.was = this.querySelector("[data-br-sticky-was]");
      this.choices = this.querySelector("[data-br-sticky-choices]");
      this.offscreen = false;
      this.pending = false;
      this.onAdd = () => this.mainButton.click();
      this.onChange = () => this.schedule();
      this.addButton.addEventListener("click", this.onAdd);
      this.info.addEventListener("change", this.onChange);
      this.watcher = new MutationObserver(this.onChange);
      this.watcher.observe(this.info, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ["disabled", "aria-disabled", "class"],
      });
      this.viewer = new IntersectionObserver((entries) => {
        this.offscreen = !entries[entries.length - 1].isIntersecting;
        this.update();
      });
      this.viewer.observe(this.mainButton);
      this.sync();
    }

    disconnectedCallback() {
      if (this.watcher) this.watcher.disconnect();
      if (this.viewer) this.viewer.disconnect();
      if (this.info) this.info.removeEventListener("change", this.onChange);
      document.body.classList.remove("br-sticky-atc-on");
    }

    schedule() {
      if (this.pending) return;
      this.pending = true;
      requestAnimationFrame(() => {
        this.pending = false;
        this.sync();
      });
    }

    sync() {
      const now = this.info.querySelector(
        ".product-info__price .price__current .js-value, .product-info__price .price__original .js-value",
      );
      const was = this.info.querySelector(".product-info__price .price__was .js-value");
      this.price.textContent = now ? now.textContent.trim() : "";
      this.was.textContent = was ? was.textContent.trim() : "";
      this.was.hidden = !was;
      this.choices.textContent = [...this.info.querySelectorAll('.variant-picker input[type="radio"]:checked')]
        .map((input) => {
          const label = input.closest("label");
          const text = label ? label.querySelector(".variant-option__button-label__text") : null;
          return (text ? text.textContent : input.value).trim();
        })
        .filter(Boolean)
        .join(" · ");
      this.addButton.disabled = this.mainButton.disabled;
      this.addButton.textContent = this.mainButton.textContent.replace(/\s+/g, " ").trim();
      if (this.mainButton.getAttribute("aria-disabled") === "true") this.addButton.setAttribute("aria-disabled", "true");
      else this.addButton.removeAttribute("aria-disabled");
      for (const state of ["is-loading", "is-success"]) {
        this.addButton.classList.toggle(state, this.mainButton.classList.contains(state));
      }
      this.update();
    }

    update() {
      const visible = this.offscreen && !this.mainButton.disabled;
      this.classList.toggle("is-visible", visible);
      this.inert = !visible;
      document.body.classList.toggle("br-sticky-atc-on", visible);
    }
  }

  customElements.define("br-sticky-atc", BrStickyAtc);
}
